import { Endpoints, queryKeys } from "../api";
import { useAxios, useGenericMutation } from "../hooks";
import { AwsFile, MutationResult } from "../models";
import { useMemo } from "react";
import { useQueryClient } from "@tanstack/react-query";

export interface IUseAwsFileQuery {
    createMutation: MutationResult<AwsFile, unknown, AwsFile>;
}

export const useAwsFileQuery = (): IUseAwsFileQuery => {
    const { post } = useAxios();

    const queryClient = useQueryClient();

    const createMutation = useGenericMutation({
        mutationFn: (data: AwsFile) => post<AwsFile>({ url: `${Endpoints.Aws}`, data }),
        queryKey: queryKeys.awsFiles.all(),
        invalidateQueryKey: false,
        onSuccess: (data) => {
            const awsFiles = queryClient.getQueryData<AwsFile[]>(queryKeys.awsFiles.all()) ?? [];
            queryClient.setQueryData(queryKeys.awsFiles.all(), [...awsFiles, data]);
        },
    });

    return useMemo<IUseAwsFileQuery>(() => ({ createMutation }), [createMutation]);
};
